import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { API_ENDPOINTS } from '../models/enums/endpoints.enum';
import { ApiProviderService } from './api-provider.service';
import { ConfirmationViewDto } from '../models/confirmation-view-dto.model';
import { mapAsBody } from '../app/shared/util/request-util';
import { PaymentMethodEnum } from '../models/enums/payment-method.enum';

@Injectable({
  providedIn: 'root',
})
export class PaymentService {
  private PAYMENT_STEP_URL = API_ENDPOINTS.PAYMENT_STEP;
  private PAYMENT_FORM_URL = API_ENDPOINTS.PAYMENT_FORM;

  /**
   * Permet d'afficher la popup "BasketNoPaidGuard" Si le client quitte le panier sans payer.
   * True: Si l'utilisateur quitte son panier via le btn "payer" ou via le btn "modifier"
   * False: Si l'utisateur quitte son panier via une autre action **/
  public goToPayment: boolean = false;

  constructor(private apiProvider: ApiProviderService) {}

  public confirmPayment(params: any): Observable<ConfirmationViewDto> {
    let url;
    if (params.indirect) {
      // retour indirect (SEPA / OFFLINE / VIREMENT_DIFF)
      if (params.basketOrderId && params.basketOrderId !== 'null') {
        url = '/order/confirmation/indirect?basketOrderId=' + params.basketOrderId;
      } else {
        url = '/order/confirmation/indirect';
      }
    } else {
      // retour automatique
      url = '/order/confirmation';
    }
    return this.apiProvider
      .post<ConfirmationViewDto>(url, null, { params, observe: 'response' })
      .pipe(mapAsBody)
      .pipe(map((res: any) => new ConfirmationViewDto(res)));
  }

  public updateBasketOrderAndTransaction(param: any): Observable<any> {
    return this.apiProvider.publicPost('/abortTransaction', param);
  }

  public redirectPayment(userTypology: PaymentMethodEnum): Observable<any> {
    return this.apiProvider.get(`${this.PAYMENT_STEP_URL}/${userTypology}`, { observe: 'response' });
  }

  public getPaymentForm(userTypology: PaymentMethodEnum, idBasketOrder?: number): Observable<any> {
    return this.apiProvider.get(`${this.PAYMENT_FORM_URL}/${userTypology}${idBasketOrder ? '?idBasket=' + idBasketOrder : ''}`, { responseType: 'text' });
  }
}
